import { render, staticRenderFns } from "./purchaseReceivingRecordAction.vue?vue&type=template&id=3fafe9d3&scoped=true"
import script from "./purchaseReceivingRecordAction.vue?vue&type=script&lang=js"
export * from "./purchaseReceivingRecordAction.vue?vue&type=script&lang=js"
import style0 from "./purchaseReceivingRecordAction.vue?vue&type=style&index=0&id=3fafe9d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fafe9d3",
  null
  
)

export default component.exports